var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-switch',{on:{"change":function($event){return _vm.toggleGuesser()}},model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}},[_vm._v("Spy Master")])}
var staticRenderFns = []

export { render, staticRenderFns }